/**
 * Paquete de ciclos D28D según plan (trimestral/bimensual/semestral…).
 * El modelo de cuenta usa cycle_id = inicio + sesiones_restantes = cycles_count.
 */

export function planCyclesIncluded(plan) {
  const n = Number(plan?.cycles_count);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.floor(n);
}

export function sortCyclesByStart(cycles = []) {
  return [...cycles].sort((a, b) => {
    const da = String(a?.startDate || a?.start_date || '');
    const db = String(b?.startDate || b?.start_date || '');
    if (da && db) return da.localeCompare(db);
    return Number(a?.id) - Number(b?.id);
  });
}

/** Desde startId, toma `count` ciclos consecutivos del pool ordenado por fecha. */
export function consecutiveCyclePack(cycles, startId, count) {
  const needed = Math.max(1, Number(count) || 1);
  const sorted = sortCyclesByStart(cycles);
  if (!sorted.length) return [];
  const idx = sorted.findIndex((c) => String(c.id) === String(startId));
  if (idx < 0) return [];
  return sorted.slice(idx, idx + needed);
}

export function cycleIdsFromPack(pack) {
  return pack.map((c) => String(c.id));
}
